import {di} from "@dp-instant/core";
import {Random} from "@dp-instant/utils";
import {BotLogic} from "@game/coregame/ecs/components/BotLogic";
import {Building} from "@game/coregame/ecs/entities/Building";
import {math} from "@game/coregame/helpers";
import {Command} from "@game/coregame/interfaces/Command";
import {Decision} from "@game/coregame/interfaces/Decision";
import {DecisionType} from "@game/coregame/interfaces/DecisionType";
import {IBotConfig} from "@game/coregame/interfaces/IBotConfig";
import {
    BotPreset0Vegetable,
    BotPreset1Easy,
    BotPreset2Medium,
    BotPreset3UpperMedium,
    BotPreset4Hard,
    BotPreset5Final,
    BotPreset6FinalAgressive
} from "@game/coregame/model/BotPresets";
import {CookieModel} from "@game/coregame/model/CookieModel";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {EntitySnapshot, IterativeSystem} from "tick-knock";
import {GamePlayEvent} from "./GamePlaySystem";
import {BotPresetsModel} from "@game/coregame/model/BotPresetsModel";

type PresetWeight = [Preset: IBotConfig, Weight: float];
type Presets = [WinsToLevelUp: int, LosesToLevelDown: int, Preset: PresetWeight[]];

export class BotsSystem extends IterativeSystem {
    private _presets: Presets[] = [
        [3, 0, [[BotPreset1Easy, 1]]],
        [2, 1, [[BotPreset2Medium, 1]]],
        [3, 1, [[BotPreset3UpperMedium, 1]]],
        [3, 1, [[BotPreset4Hard, 1]]],
        [3, 1, [[BotPreset6FinalAgressive, 1]]]
    ];
    private model: GameModel;
    private cookie: CookieModel;
    private _startBot: IBotConfig = BotPreset0Vegetable;
    private _lowLevelPresetEveryFights: int = 3;
    private _gameplayEventHandler = this.gameplayEventHandler.bind(this);

    constructor() {
        super(entity => entity.has(BotLogic));
    }
    // public update(dt: number) {
    //     log.trace("BotDecision " + this.entities.map(a => (a as Building).stateId));
    //     super.update(dt);
    // }
    protected updateEntity(entity: Building, dt: number) {
        const logic = entity.get(BotLogic);
        if (!logic) return;
        if (!logic.initialized) {
            logic.init(this.selectPreset());
        }
        const command = logic.decide(entity);
        if (!command) return;
        logic.executeDecision(this.convertToDecision(command));
    }
    private convertToDecision(command: Command): Decision {
        const model: GameModel = di.get(TypesGame.model);
        const getBuilding = (id: string) => model.currentContinent.buildings.get(id);
        switch (command.Type) {
            case DecisionType.Move:
                const Objects: Building[] = [];
                for (const source of command.Objects) {
                    Objects.push(getBuilding(source.Id)!);
                }
                return {
                    Type: DecisionType.Move,
                    Subject: getBuilding(command.Subject.Id)!,
                    Objects
                };
        }
        return {
            Type: DecisionType.Wait,
            Objects: [],
            Subject: {} as Building
        };
    }
    protected entityAdded = (snapshot: EntitySnapshot) => {
        const {current: entity} = snapshot;
        const logic: BotLogic = entity.get(BotLogic)!;
        logic.init(this.selectPreset());
    };
    protected selectPreset(): IBotConfig {
        const botPresetsModel = di.get<BotPresetsModel>(TypesGame.botPresetsModel);
        const preset = botPresetsModel.selectPreset();
        return preset;
    }
    private gameplayEventHandler() {
        //
    }
    onAddedToEngine() {
        super.onAddedToEngine();
        this.cookie = di.get(TypesGame.cookieModel);
        this.model = di.get(TypesGame.model);
        this.engine.subscribe(GamePlayEvent, this._gameplayEventHandler);
    }
    onRemovedFromEngine() {
        this.entities.forEach(e => e.get(BotLogic)?.terminate());
        this.engine.unsubscribe(GamePlayEvent, this._gameplayEventHandler);
        super.onRemovedFromEngine();
    }
}
